import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  ViewChild,
  OnInit,
  OnDestroy,
  EventEmitter,
  Output,
} from '@angular/core';
@Component({
  selector: 'vm-hero-bg-video',
  templateUrl: './hero-bg-video.component.html',
  styleUrls: ['./hero-bg-video.component.scss'],
})
export class HeroBgVideoComponent implements OnInit, OnDestroy {
  @Input() videoUrl: string;
  @Input() videoBottomCurve: boolean;
  @Input() minScreenSize: number;
  @Input() maxScreenSize: number;
  @Output() intrinsicVideoHeightToWidth: EventEmitter<any> = new EventEmitter();
  @ViewChild('myHeroVideo', { static: true }) myVideo: any;
  playState = null;
  video: any = {};
  isMinWidth = true;
  private intersectionObserver?: IntersectionObserver;

  constructor(private changeDetector: ChangeDetectorRef) {}

  @HostListener('document:scroll') onScroll(): void {
    this.onVisibilityChange();
  }
  @HostListener('window:resize') onResize(): void {
    let isScreenSizeApplicable = false;
    const element = this.myVideo.nativeElement;
    this.intrinsicVideoHeightToWidth.emit({
      intrinsicHeight: element.videoHeight,
      intrinsicWidth: element.videoWidth,
    });
    if (this.minScreenSize && this.maxScreenSize) {
      isScreenSizeApplicable = window.innerWidth >= this.minScreenSize && window.innerWidth < this.maxScreenSize;
    } else if (this.minScreenSize && !this.maxScreenSize) {
      isScreenSizeApplicable = window.innerWidth >= this.minScreenSize;
    } else if (!this.minScreenSize && this.maxScreenSize) {
      isScreenSizeApplicable = window.innerWidth < this.maxScreenSize;
    }
    if (isScreenSizeApplicable && window.innerWidth > this.video.videoWidth) {
      this.isMinWidth = true;
    } else if (isScreenSizeApplicable && window.innerWidth < this.video.videoWidth) {
      this.isMinWidth = false;
    }
    this.changeDetector.detectChanges();
  }
  onVisibilityChange = () => {
    if (document.hidden || !this.playState) {
      this.video.pause();
      this.video.currentTime = 0;
    } else {
      this.video.play();
    }
  };
  ngOnInit(): void {
    this.video = this.myVideo.nativeElement;
    this.video.addEventListener('loadedmetadata', (element) => {
      this.intrinsicVideoHeightToWidth.emit({
        intrinsicHeight: element.target.videoHeight,
        intrinsicWidth: element.target.videoWidth,
      });
      if (window.innerWidth < element.currentTarget.videoWidth) {
        this.isMinWidth = false;
      }
    });
    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          this.video.pause();
          this.video.currentTime = 0;
          this.playState = false;
        } else {
          this.video.play();
          this.playState = true;
        }
      });
    }, {});
    this.intersectionObserver.observe(this.video);
  }
  ngOnDestroy() {
    if (this.intersectionObserver) {
      this.intersectionObserver.unobserve(this.video);
      this.intersectionObserver.disconnect();
    }
  }
}
